// Binding handler om een J/N waarde te tonen
export class TextJNBindingHandler implements KnockoutBindingHandler {
    public update(element: Node, valueAccessor: () => any) {
        let value = ko.unwrap(valueAccessor());
        if (value) {
            let textValue;
            if (value === "J") {
                textValue = "Ja";
            } else {
                textValue = "Nee";
            }
            $(element).html(textValue);
        }
    }
}
